import React from "react";

const Portfolio = () => {
  return <>Portfolio page</>;
};

export { Portfolio };
